/**
 * Created by Stefann on 12/11/2018.
 */
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import store from './store';
import { Question } from '@/lib/Question';
import { Pack } from '@/lib/Pack';
import { Guarantee } from '@/lib/Guarantee';
import { PackCategory } from "@/lib/PackCategory";
import { PackGuarantee } from "./lib/PackGuarantee";
import { ResponseGroup } from "./lib/ResponseGroup";
import { helper } from './Utils/Helper';
// import {forestgreen} from "color-name";
// import {ResponseGroup} from "@/lib/ResponseGroup";
// import {config} from "@vue/test-utils";

export type Callable = () => any;

class Api {
    public client: AxiosInstance;
    public secureClient: AxiosInstance;
    public storageClient: AxiosInstance;
    public permissionApi: AxiosInstance;
    public permissionApiKey = process.env.VUE_APP_PERMISSION_API_KEY;
    public env = process.env.VUE_APP_ENV;
    public disableCache = true;

    public refreshToken: string = '';
    public accessToken: string = '';
    public mercureToken: string = '';
    private questionsDebounce: any = [];
    public months: any = ['Janv', 'Fev', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Sept', 'Oct', 'Nov', 'Dec'];


    constructor() {
        if ((typeof process.env.VUE_APP_CLOUD_STORAGE_DISABLE_CACHE) == 'string') {
            this.disableCache = !!process.env.VUE_APP_CLOUD_STORAGE_DISABLE_CACHE;
        }
        const baseUrl = process.env.VUE_APP_BACKEND_URL + 'front/api/';
        const permissionApiUrl = process.env.VUE_APP_PERMISSION_API_URL;
        const headers: any = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            // 'X-Requested-With': 'XMLHttpRequest',
        };
        const secureBaseUrl = baseUrl + 'secure/';
        const storageParams: any = {
            baseURL: process.env.VUE_APP_CLOUD_STORAGE_URL + process.env.VUE_APP_CLOUD_STORAGE_ROOT_FOLDER + '/',
            headers,
            params: {
                ignoreCache: Math.random()
            }


        };
        if (!this.disableCache) {
            storageParams.params = {
                ignoreCache: Math.random(),
            };
        }
        this.storageClient = axios.create(storageParams);
        const refreshToken = this.getCookie('refreshToken');
        if (refreshToken.length) {
            this.refreshToken = refreshToken;
        }

        this.client = axios.create(
            {
                baseURL: baseUrl,
                // withCredentials: true,
                headers
            },
        );
        this.permissionApi = axios.create(
            {
                baseURL: permissionApiUrl,
                withCredentials: true,
                headers,
                params: {
                    apiKey: this.permissionApiKey,
                },
                data: {},
            },
        );
        this.secureClient = axios.create(
            {
                baseURL: secureBaseUrl,
                withCredentials: true,
                headers,
            },
        );
        [this.secureClient, this.permissionApi, this.client].forEach((client: AxiosInstance) => {
            client.interceptors.response.use((response) => response, (error) => {
                console.log(error);
                if (error.response) {
                    store.commit('throwError', "Une erreur est survenue lors du traitement de votre requête. Merci de réessayer plus tard. Si le problème persiste, merci de nous contacter à l'adresse bonjour@wiassur.com ou d'utiliser le tchat qui s'affiche en bas de page.")
                } else if (error.request) {

                    store.commit('throwError', 'Impossible de joindre le serveur de Wiassur, merci de vérifier votre connexion internet et réessayer.');
                } else {
                    // Something happened in setting up the request that triggered an Error
                    store.commit('throwError', 'Impossible de joindre le serveur de Wiassur, merci de vérifier votre connexion internet et réessayer.');
                }
                store.commit('loaded');
            });
        });
        [this.secureClient, this.permissionApi].forEach(
            (client: AxiosInstance) => {
                const loginPath = this.getRoute('login');
                client.interceptors.request.use((config: AxiosRequestConfig) => {
                    console.log(baseUrl, secureBaseUrl, config.baseURL);
                    if (this.accessToken.length && [process.env.VUE_APP_PERMISSION_API_URL, baseUrl, secureBaseUrl].includes(config.baseURL) && (config.url !== loginPath)) {
                        console.log("added tokens");
                        config.headers.Authorization = `Bearer ${this.accessToken}`;
                    }
                    return config;
                },
                    (error: AxiosError) => {
                        if (error.response && error.response.status === 401) {

                        }
                    }
                );

            });
    }

    public getCloudFilePath(folder: string, filename: string) {
        return process.env.VUE_APP_CLOUD_STORAGE_URL + process.env.VUE_APP_CLOUD_STORAGE_ROOT_FOLDER + '/' + folder + filename;
    }


    public getRoute(
        name:
            'init' |
            'saveSubscriberData' |
            'login' |
            'filterQuestion' |
            'saveAnswer' |
            'removeAnswer' |
            'loadResponseGroup' |
            'loadResponseGroupWithContractUuid' |
            'deleteResponseGroup' |
            'compare' |
            'compareInsurerLock' |
            'saveOrder' |
            'pay' |
            'paymentStatus' |
            'notifyNewBranch' |
            'getOrder' |
            'getResponseGroupsInfos' |
            'removeSectionAnswers' |
            'user' |
            'updateOrderDeliveryData' |
            'loadTowns' |
            'accountBalance' |
            'sendDeliveryMail' |
            'requestQuotation' |
            'uploadExcel' |
            'getObjectsFromResponseGroup' |
            'loadHealthSurveyForm' |
            'refreshToken' |
            'getPartnerInfos' |
            'createChoice',
        params: any = {}) {
        // const defaultParameters: any[] = [];
        // for (const parameter of defaultParameters) {
        //     if (!params.hasOwnProperty(parameter)) {
        //         params[parameter] = '0';
        //     }
        // }
        const routes = {
            init: `forms.json`,
            saveSubscriberData: `save/subscriber/data/${params.uuid}`,
            refreshToken: `api/token/refresh`,
            getObjectsFromResponseGroup: `get-objects-from-response-group/${params.id}`,
            loadTowns: `towns`,
            login: `api/login`,
            updateOrderDeliveryData: `save-delivery-information/${params.orderId}`,
            sendDeliveryMail: `send-delivery-mail/${params.uuid}/${params.onDeliveryPayment}`,
            filterQuestion: `filter-choices/${params.className}`,
            saveAnswer: `answer`,
            user: `user`,
            requestQuotation: `request-quotation/${params.responseGroupId}`,
            removeSectionAnswers: `remove-section-answers`,
            notifyNewBranch: `branches/notify`,
            removeAnswer: `answer/${params.id}`,
            loadResponseGroup: `load-response-group/${params.branchId}/${params.id}`,
            loadResponseGroupWithContractUuid: `load-response-group/${params.branchId}/${params.id}/${params.uuid}`,
            deleteResponseGroup: `response-group/${params.id}`,
            compare: `compare/${params.responseGroupId}`,
            compareInsurerLock: `compare/${params.responseGroupId}/${params.id}`,
            saveOrder: `order`,
            getResponseGroupsInfos: `get/response/groups/infos/${params.rgs}`,
            getOrder: `order/${params.orderId}`,
            pay: `payment/pay?test_token=${params}`,
            uploadExcel: `add-excel/${params.responseGroupId}`,
            paymentStatus: `payment/status/${params.transactionId}`,
            accountBalance: `payment/account/${params.id}`,
            loadHealthSurveyForm: `load-order-health-survey/${params.orderId}`,
            getPartnerInfos: `get/partner/infos/${params.code}`,
            createChoice: `create/choice/${params.type}/${params.value}/${params.filteredBy}`,

        };
        return routes[name];
    }

    public sendDeliveryMail(uuid: string, onDeliveryPayment = "no") {
        return this.client.get(this.getRoute("sendDeliveryMail", { uuid, onDeliveryPayment }));
    }

    public saveSubscriberData(uuid: string, data: any) {
        this.setCookie('subscriberData', JSON.stringify(data), 365);
        return this.client.post(this.getRoute("saveSubscriberData", { uuid }), data);
    }

    public uploadExcel(params: any) {
        return this.client.post(this.getRoute('uploadExcel', params), params.data, { onUploadProgress: params.onUploadProgress });
    }

    public loadSurveyForm(orderId: number) {
        return this.client.get(this.getRoute('loadHealthSurveyForm', { orderId }));
    }

    public requestQuotation(uuid: string) {
        return this.client.post(this.getRoute("requestQuotation", { responseGroupId: uuid }));
    }

    public updateOrderDeliveryData(orderId: any, data: any) {
        return this.client.post(this.getRoute('updateOrderDeliveryData', { orderId }), data)
    }

    public getObjectsFromResponseGroup(responseGroup: ResponseGroup) {
        console.log(responseGroup);
        return this.client.get(this.getRoute('getObjectsFromResponseGroup', { id: responseGroup.id }));
    }

    public createChoice(type: string, value: string, filteredBy) {
        return this.client.get(this.getRoute('createChoice', { type, value, filteredBy }));
    }

    public loadResponseGroup(branchId: number, id: any): any {
        // if (store.state.currentBranch) {
        //     if (store.state.currentBranch.slug === 'auto') {
        //         store.commit('showBanner');
        //     }
        // }
        const partner: any = store.state.partner

        if (store.state.currentContractGroupUuid) {
            const route = this.getRoute('loadResponseGroupWithContractUuid', {
                branchId,
                id,
                'uuid': store.state.currentContractGroupUuid,
            });
            return this.client.get(route);
        }
        return this.client.get(this.getRoute('loadResponseGroup', { branchId, id }), { params: { partner: store.state.partner } });
    }

    public deleteResponseGroup(id: any): any {
        return this.client.delete(this.getRoute('deleteResponseGroup', { id }));
    }

    public loadTowns() {
        return this.client.get(this.getRoute('loadTowns'));
    }

    public getAccountBalance(id: string) {
        return this.client.get(this.getRoute('accountBalance', { id }));
    }

    public removeSectionAnswers(responseGroupId: any, sectionId: number, additionalIndex: number) {
        return this.client.delete(this.getRoute('removeSectionAnswers'), {
            params: {
                id: sectionId,
                responseGroupId,
                additionalIndex,
            },
        });
    }

    public getPartnerInfos(code: string) {
        return this.client.get(this.getRoute('getPartnerInfos', { code }));
    }

    public notifyNewBranch(params: any): any {
        return this.client.get(this.getRoute('notifyNewBranch'), { params });
    }

    public removeAnswer(id: number): any {
        return this.client.delete(this.getRoute('removeAnswer', { id }));
    }

    public pay(options: any, testToken: any) {
        return this.client.post(this.getRoute('pay', testToken), options);
    }

    public paymentStatus(transactionId: string) {
        return this.client.get(this.getRoute('paymentStatus', { transactionId }));
    }

    public getOrder(id: number): any {
        return this.client.get(this.getRoute('getOrder', { orderId: id }));
    }

    public getResponseGroupsInfos(responseGroups: any) {

        let ar: any[] = [];
        if (Array.isArray(responseGroups)) {
            responseGroups.forEach((responseGroup) => {
                ar.push(responseGroup.id);
            });
        }
        const rgs = JSON.stringify(ar);
        return this.client.get(this.getRoute('getResponseGroupsInfos', { rgs }));
    }

    public order(pack: Pack, responseGroup: any) {

        const params = {
            pack: pack.id,
            premium: pack.premium,
            guarantees: pack.guarantees.filter((packGuarantee: PackGuarantee) => {
                return packGuarantee.isSelected;
            }).map((packGuarantee: PackGuarantee) => packGuarantee.id),
            period: store.state.currentInsuranceDuration,
            responseGroup,
            startDate: store.state.startDate
                ? store.state.startDate.getTime()
                : new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).getTime(),
        };

        return this.client.get(this.getRoute('saveOrder'), { params });
    }

    public login(email: string, password: string) {
        this.permissionApi.post(this.getRoute('login'), { username: email, password },
            {
                params: {
                    apiKey: process.env.VUE_APP_PERMISSION_API_KEY
                }
            })
            .then((response: AxiosResponse) => {
                console.log(response);
                this.authenticate(response.data);
            },
                (error) => {
                    store.commit('throwError', error.response.data.message);
                    store.commit('loaded');
                });
    }

    private authenticate(data: any) {
        this.accessToken = data.token;
        this.refreshToken = data.refreshToken;
        this.mercureToken = data.mercure;
        this.setCookie('refreshToken', this.refreshToken, parseInt(process.env.VUE_APP_REFRESH_TOKEN_VALIDITY_DAYS!));
        this.loadUserData();
    }

    public loadUserData(next?: Callable) {
        this.secureClient.get(this.getRoute('user')).then((response: AxiosResponse) => {
            store.commit('user', response.data.data.user);
        },
            (error) => {
                store.commit('throwError', error.response.data.message);
                store.commit('loaded');
            });
    }

    public init(next: Callable): any {
        if (store.state.isInitialized) {
            next();
            return;
        }
        store.commit('loading');

        let promises: any[] = []
        // if (this.env === 'prod') {
        //     promises = [
        //         this.storageClient.get(store.state.tenant.iso + '.json?cache='+ helper.generateId()).then((response: AxiosResponse) => {
        //             return store.dispatch('init', response.data);
        //         }),
        //     ];
        // } else {
        promises = [
            this.client.get(store.state.tenant.iso + '.json?cache=' + helper.generateId()).then((response: AxiosResponse) => {
                return store.dispatch('init', response.data);
            }),
        ];
        // }
        if (this.refreshToken.length) {
            promises.push(this.permissionApi.post(this.getRoute("refreshToken"), {
                refreshToken: this.refreshToken,
            }).then((response: AxiosResponse) => {
                console.log(response.status);
            }).catch((reason) => {
                console.log(reason);
            }));
        }
        Promise.all(promises).then(() => {

            store.commit('loaded');
            next();
        })
            .catch((reason) => {
                console.log(reason);
            });
        // this.client.get(this.getRoute('init')).then((response: AxiosResponse) => {
        //     store.dispatch('init', response.data.data).then(() => {
        //         store.commit('loaded');
        //         next();
        //     });
        // });
    }

    public saveAnswer(question: Question) {
        /** @var Response response */
        const response = store.getters.getCurrentResponse(question);
        // console.log(response);
        if (!response) {
            return;
        }
        if (this.questionsDebounce[response.question.id]) {
            clearTimeout(this.questionsDebounce[response.question.id]);
        }
        return new Promise((resolve, reject) => {
            this.questionsDebounce[response.question.id] = setTimeout(() => {
                store.commit("saving");
                this.client.post(this.getRoute('saveAnswer'), {
                    question: {
                        id: response.question.id,
                        originalId: question.originalId,
                    },
                    response: {
                        valueId: response.valueId,
                        value: Question.transform(response.value, question.responseType.template),
                        comment: response.comment,
                        customData: response.customData,
                    },
                    responseGroup: {
                        id: response.responseGroup.id || 0,
                    },
                    branch: {
                        id: response.responseGroup.branch.id,
                    },
                    additionalIndex: response.additionalIndex,
                }).then((response: AxiosResponse) => resolve(response));
            }, 1000);
        });

    }

    public async compare(parameters: any) {
        const responseGroupId = parameters.responseGroupId;
        const routeParams: any = { responseGroupId };
        let routeName = 'compare';
        if (store.state.insurerLock) {
            routeParams.id = store.state.insurerLock.id;
            routeName = 'compareInsurerLock';
        }
        return this.client.get(this.getRoute(routeName as any, routeParams), { params: { filters: parameters.filters } });
    }

    public filterQuestion(question: Question, search: string = '', page: number = 1) {
        const params: any = {
            search,
            page,
        };
        if (question.filteredByQuestionId) {
            const filteredBy = store.getters.getQuestion(question.filteredByQuestionId);
            if (filteredBy) {
                params.questionId = question.originalId || question.id;
                params.objectId = filteredBy.currentResponse.valueId;
            }

        }
        return this.client.get(
            this.getRoute(
                'filterQuestion',
                { className: question.responseType.className }), { params });
    }

    public setCookie(cookieName: string, cookieValue: string, validityDays: number) {
        const d = new Date();
        if (!validityDays) {
            validityDays = 30;
        }
        d.setTime(d.getTime() + (validityDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        const parts = window.location.hostname.split('.');
        let topDomain = window.location.hostname;
        if (parts.length > 2) {
            topDomain = '.' + parts[parts.length - 2] + '.' + parts[parts.length - 1];
        }

        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";domain=" + topDomain + ";path=/";
    }

    public getCookie(cname: string) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    public getCookies() {
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        let cookies = [];
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            const branches = store.state.branches;
            if (c.includes('=')) {
                const content = c.split('=');
                if (content.length == 2) {
                    cookies.push({ name: content[0], value: content[1].replace('rg_', '') });
                }
            }
        }
        return cookies;
    }

    loadRgs() {
        const rgs = api.getLocalResponseGroups();
        if (rgs.length > 0) {
            store.commit('loadCookieRgs', rgs);
        }
        if (rgs.length > 5) {
            this.deleteCookie('rg_' + rgs[0].uuid)
        }
        return rgs
    }

    public getLocalResponseGroups() {
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        let rgs: any = [];
        const branches = store.state.branches;
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.startsWith('rg_')) {
                const content = c.split('=');
                const uuid = content[0].replace('rg_', '')
                const data = content[1].split(',')
                const rg = {
                    uuid: uuid, slug: data[0], title: data[1], icon: data[2], date: new Date((Number(data[3]))),
                    branchId: Number(data[4])
                }
                rgs.push(rg)
            }

            if (c.includes('=')) {
                const content = c.split('=');
                if (content.length == 2) {
                    if (content[1].startsWith('rg_')) {
                        this.deleteCookie(content[0])
                    }
                }
            }
        }
        return rgs;
    }

    public deleteCookie(cname: string) {
        const parts = window.location.hostname.split('.');
        let topDomain = window.location.hostname;
        if (parts.length > 2) {
            topDomain = parts[parts.length - 2] + '.' + parts[parts.length - 1];
        }
        document.cookie = cname + '=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + topDomain + ';path=/';
    }


    logout() {
        this.setCookie('refreshToken', '', -100);
    }
}


export let api = new Api();

